document.addEventListener('DOMContentLoaded', function () {

    // Check if the filter panel exists
    const filterPanel = document.querySelector('.advance-filter-popup');
    if (!filterPanel) return;

    // Initialize the filters object
    let filters = {};

    // Reference to the hidden input for storing the filter data
    const filterObjectInput = document.getElementById('advance-filter-object');

    // Sorting
    const sortingSelect = document.getElementById('advance-filter-sorting');
    sortingSelect.addEventListener('change', function () {
        const selectedValue = this.value;
        filters.sorting = selectedValue;
        updateFilterObject();
        updateUrlQueryParams();  // Update URL when filter changes
    });

    // Budget tabs (desktop)
    const budgetTabs = document.querySelectorAll('#advance-filter-budget-type .mj-advance-filters__budget-tab');
    const budgetTabsContent = document.querySelectorAll('.mj-advance-filters__budget-tab-content');
    budgetTabs.forEach(tab => {
        tab.addEventListener('click', function () {
            budgetTabs.forEach(t => t.classList.remove('--active'));
            this.classList.add('--active');
            const selectedTab = this.getAttribute('data-tab');

            budgetTabsContent.forEach(t => t.classList.remove('--active'));
            // document.querySelector('.mj-advance-filters__budget-tab-content[]')
            // selectedTab

            filters.budget = selectedTab;
            updateFilterObject();
            updateUrlQueryParams();  // Update URL when filter changes
        });
    });

    // Budget (mobile)
    const budgetMobileSelect = document.getElementById('advance-filter-budget-type-mobile');
    budgetMobileSelect.addEventListener('change', function () {
        const selectedValue = this.value;
        filters.budget = selectedValue;
        updateFilterObject();
        updateUrlQueryParams();  // Update URL when filter changes
    });

    // Budget range (from/to)
    const budgetFromInput = document.getElementById('advance-filter-budget-from');
    const budgetToInput = document.getElementById('advance-filter-budget-to');

    budgetFromInput.addEventListener('change', function () {
        filters.budgetFrom = this.value;
        updateFilterObject();
        updateUrlQueryParams();  // Update URL when filter changes
    });

    budgetToInput.addEventListener('change', function () {
        filters.budgetTo = this.value;
        updateFilterObject();
        updateUrlQueryParams();  // Update URL when filter changes
    });

    // Bedroom number filter
    const bedroomNumberInput = document.getElementById('advance-filter-bedroom-number');
    bedroomNumberInput.addEventListener('change', function () {
        filters.bedrooms = this.value;
        updateFilterObject();
        updateUrlQueryParams();  // Update URL when filter changes
    });

    // Checkbox filters
    function handleCheckboxChange(checkboxGroupId, filterKey) {
        const checkboxes = document.querySelectorAll(`#${checkboxGroupId} input[type="checkbox"]`);
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', function () {
                const selectedValues = Array.from(checkboxes)
                    .filter(cb => cb.checked)
                    .map(cb => cb.value)
                    .join(',');
                filters[filterKey] = selectedValues;
                updateFilterObject();
                updateUrlQueryParams();  // Update URL when filter changes
            });
        });
    }

    // Call the function for each group of checkboxes
    handleCheckboxChange('advance-filter-venue-types', 'venueTypes');
    handleCheckboxChange('advance-filter-venue-cuisine', 'venueCuisines');
    handleCheckboxChange('advance-filter-venue-features', 'venueFeatures');
    handleCheckboxChange('advance-filter-venue-amenities', 'venueAmenities');


    // Update the hidden input with filter data as a JSON string
    function updateFilterObject() {
        filterObjectInput.value = JSON.stringify(filters);

        // Add or remove --applied class for each filter element
        applyClassIfChanged(sortingSelect, filters.sorting);
        applyClassIfChanged(budgetMobileSelect, filters.budget);
        applyClassIfChanged(budgetFromInput, filters.budgetFrom);
        applyClassIfChanged(budgetToInput, filters.budgetTo);
        applyClassIfChanged(bedroomNumberInput, filters.bedrooms);
        applyCheckboxAppliedClass('advance-filter-venue-types', filters.venueTypes);
        applyCheckboxAppliedClass('advance-filter-venue-cuisine', filters.venueCuisines);
        applyCheckboxAppliedClass('advance-filter-venue-features', filters.venueFeatures);
        applyCheckboxAppliedClass('advance-filter-venue-amenities', filters.venueAmenities);
    }

    // Helper to apply/remove --applied class based on default values
    function applyClassIfChanged(element, value) {
        if (value && value !== element.getAttribute('default-value')) {
            element.classList.add('--applied');
        } else {
            element.classList.remove('--applied');
        }
    }

    // Helper to apply/remove --applied class for checkboxes
    function applyCheckboxAppliedClass(checkboxGroupId, filterValue) {
        const checkboxGroup = document.getElementById(checkboxGroupId);
        if (filterValue) {
            checkboxGroup.classList.add('--applied');
        } else {
            checkboxGroup.classList.remove('--applied');
        }
    }

    // Function to update the URL without reloading the page
    function updateUrlQueryParams() {
        const currentParams = new URLSearchParams(window.location.search);

        // Iterate through the filters object to update existing parameters or add new ones
        for (const [key, value] of Object.entries(filters)) {
            currentParams.set(key, value); // This replaces the value if the key exists, otherwise adds a new parameter
        }

        const newUrl = `${window.location.pathname}?${currentParams.toString()}`;

        // Use history.pushState to update the URL without reloading the page
        window.history.pushState({}, '', newUrl);
    }


    // Show Results button
    document.querySelector('.mj-advance-filters__filter-btn').addEventListener('click', function () {
        updateUrlQueryParams();
        applyQueryParamsFilter();
        const popupElement = document.querySelector('.advance-filter-popup');

        if (popupElement.classList.contains('jupiterx-popup--show-state')) {
            popupElement.classList.remove('jupiterx-popup--show-state');
            popupElement.classList.add('jupiterx-popup--hide-state');
        }
        // window.location.href = `${window.location.pathname}?${queryString}`;
    });

    // Erase All button
    document.querySelector('.mj-advance-filters__clear-btn').addEventListener('click', function () {
        filters = {}; // Reset filters
        updateFilterObject(); // Reset the hidden input
        resetFiltersAndSorting(); // Optionally reset the form UI
    });
});

// Optionally reset the form UI when filters are erased
function resetFiltersAndSorting() {
    // Clear URL query parameters and update browser history
    const url = new URL(window.location.href);
    url.search = ''; // Removes all query parameters
    const newUrl = url.href;
    window.history.pushState({}, '', newUrl);

    // Clear the value of elements using jQuery
    jQuery('.missjones-widget-applied-filters').val('');

    // Clear search form input
    const searchForm = document.querySelector('#mj-form__search');
    if (searchForm) {
        searchForm.value = '';
    }

    // Reset filter buttons
    const filterBtns = document.querySelectorAll('.filter__btn');
    if (filterBtns.length > 0) {
        filterBtns.forEach(function (filterBtn) {
            // Remove --active class from filter buttons
            if (filterBtn.classList.contains('--active')) {
                filterBtn.classList.remove('--active');
            }

            // Clear input values for filter buttons
            if (filterBtn.tagName.toLowerCase() === 'input') {
                filterBtn.value = '';
            }

            // Reset guest buttons
            const guestBtns = document.querySelectorAll('.mj-form__filter-layouts .mj-guests__btn');
            guestBtns.forEach(function (guestBtn) {
                if (guestBtn.classList.contains('--active')) {
                    guestBtn.classList.remove('--active');
                }
            });
        });
    }

    // Reset sorting and other fields
    const sortingSelect = document.querySelector('select[name="advance-filter-sorting"]');
    const budgetMobileSelect = document.querySelector('select[name="advance-filter-budget-type"]');
    const budgetFromInput = document.querySelector('input[name="advance-filter-budget-from"]');
    const budgetToInput = document.querySelector('input[name="advance-filter-budget-to"]');
    const bedroomNumberInput = document.querySelector('input[name="advance-filter-bedroom-number"]');

    if (sortingSelect) {
        sortingSelect.value = sortingSelect.getAttribute('default-value');
        budgetMobileSelect.value = budgetMobileSelect.getAttribute('default-value');
        budgetFromInput.value = '';
        budgetToInput.value = '';
        bedroomNumberInput.value = '';
    }

    // Uncheck all checkboxes
    document.querySelectorAll('.mj-form__checkbox-wrapper input[type="checkbox"]').forEach(cb => cb.checked = false);

    // Remove active class from budget tabs
    document.querySelectorAll('.mj-advance-filters__budget-tab').forEach(tab => tab.classList.remove('--active'));

    // Remove applied classes
    document.querySelectorAll('.--applied').forEach(el => el.classList.remove('--applied'));

    // Call additional function for query parameters filter if needed
    applyQueryParamsFilter();
}